import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEFAULT_THEME_COLOR } from '../constants/theme';

const applyThemeColor = (settings) => {
	const color = settings?.theme?.color || DEFAULT_THEME_COLOR;

	document.documentElement.style.setProperty('--theme-color', color);
};

const useCompanyStore = create(
	persist(
		(set) => ({
			companySettings: { settings: {}, scheduleSettings: {} },
			setCompanySettings: (newSettings) => {
				set((state) => ({
					companySettings: { ...state.companySettings, ...newSettings }
				}));
				applyThemeColor(newSettings?.settings);
			},
			clearCompanySettings: () => {
				const defaultSettings = { settings: {}, scheduleSettings: {} };
				set({ companySettings: defaultSettings });
				applyThemeColor(null);

				['token', 'slug'].forEach((key) => localStorage.removeItem(key));
			}
		}),
		{
			name: 'companySettings',
			partialize: (state) => ({ companySettings: state.companySettings }),
			onRehydrateStorage: () => (state) => {
				applyThemeColor(state?.companySettings?.settings);
			}
		}
	)
);

export default useCompanyStore;
